import { IRoleActionTypes, eRoleActionTypeIds } from "../../action-types/user/IRoleActionTypes";
import { IRoleReducer } from "../../reducer-model/user/IRoleReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IRoleReducer = {
    status: eReducerStatusBase.is_not_initialization,
    roles: []
}
export const roleReducer = (state: IRoleReducer=iniState, action: IRoleActionTypes): IRoleReducer => {
    switch (action.type) {
        case eRoleActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eRoleActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                roles: action.payload
            }
        case eRoleActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}